import { render, staticRenderFns } from "./ngo-admin-update.vue?vue&type=template&id=1c7206a6&scoped=true&"
import script from "./ngo-admin-update.vue?vue&type=script&lang=js&"
export * from "./ngo-admin-update.vue?vue&type=script&lang=js&"
import style0 from "./ngo-admin-update.vue?vue&type=style&index=0&id=1c7206a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7206a6",
  null
  
)

export default component.exports